export default __webpack_public_path__ + "static/media/sponsor-gf.549465b6.jpg";